import React from 'react';
import PropTypes from 'prop-types';
import { PREVIEW_ONLY_MESSAGE } from '../../utils/previewReadOnly';

/**
 * PreviewNotice Component
 *
 * One-line explanation shown next to a guest control that is disabled in the portal's
 * read-only visual preview. Give it an `id` and point the control's `aria-describedby` at it.
 */
const PreviewNotice = ({ id, className = '' }) => (
  <p
    id={id}
    role="note"
    className={`rounded-lg border border-accent bg-accent-20 px-3 py-2 text-xs text-secondary ${className}`.trim()}
  >
    {PREVIEW_ONLY_MESSAGE}
  </p>
);

PreviewNotice.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
};

export default PreviewNotice;
